export default function ShopPage() {
  return <div>فروشگاه</div>;
}
